// extracted by mini-css-extract-plugin
export default {"tooltip":"nQ-z","arrow":"oQ-z"};